export default __webpack_public_path__ + "static/media/scope.160ee668.jpg";